import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractConsentAudit.List.IRequest;
type Response = Api.Core.ContractConsentAudit.List.IResponse;
type Headers = Api.Core.ContractConsentAudit.List.IHeaders;
const url = '/api/Sales/ContractConsentAudit';
export default async function contractConsentAuditListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
